import { gql } from '@apollo/client';

export const BASIC_ADDRESS_FRAGMENT = gql`
    fragment BasicAddress on Address {
        id
        line1
        line2
        city
        state
        zipCode
    }
`;
